<style lang="scss" scoped>
.textAdd {
  /deep/ {
    .el-dialog__body {
      padding: 60px 20px 30px;
    }
  }
  .content {
    position: relative;
    padding: 14px 20px;
    height: 188px;
    border: 1px solid #dcdfe6;
    width: 800px;
    margin: 0 auto;
  }
  .text {
    color: #353535;
    height: 148px;
    overflow-y: auto;
    word-break: break-all;
    line-height: 20px;
    /deep/ .emoji {
      background: transparent !important;
      cursor: unset;
      vertical-align: -8px;
    }
  }
  .footer {
    box-sizing: border-box;
    padding: 0 20px;
    color: #9a9a9a;
    border-top: 1px solid #dcdfe6;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 40px;
    line-height: 40px;
  }
}

/deep/ .emoji {
  display: inline-block;
  cursor: pointer;
  width: 25px;
  &:hover {
    background: #efefef;
  }
}
</style>

<template>
  <div>
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="新建文字"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="textAdd"
      :append-to-body="true"
      @opened="setFocus()"
    >
      <div class="content">
        <div
          class="text"
          contenteditable
          @blur="setSel"
          @input="input($event)"
          ref="contenteditable"
        ></div>
        <div class="footer clearfix">
          <el-popover placement="bottom-start" width="400" trigger="click">
            <div class="fl pointer" slot="reference">
              <i class="iconfont iconbiaoqing"></i>
            </div>
            <div class="clearfix">
              <img
                class="emoji"
                :src="`${publicPath}emoji/${item.name}.png`"
                v-for="item in emoji"
                @click="addEmoji(item)"
              >
            </div>
          </el-popover>
          <div class="fr">还可以输入{{600 - content.length}}字，按下Enter键换行</div>
        </div>
      </div>
      <div class="alignc mt100">
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import emojiMap from '@/assets/encode-mapping';

export default {
  components: {},
  computed: {},
  data() {
    let emoji = [];
    for (const key in emojiMap) {
      emoji.push({
        key,
        name: emojiMap[key].name,
      });
    }
    return {
      publicPath: process.env.BASE_URL,
      emoji,
      content: '',
      dialog: false,
    };
  },
  methods: {
    async save() {
      console.log(this.content);
      if (this.content) {
        let material = {
          type: 1,
          content: {
            text: JSON.stringify([this.content, this.filter(this.content)]),
          },
        };
        this.$emit('confirm', material);
        this.dialog = false;
      } else {
        this.$message.error(`请完善信息`);
      }
    },
    filter(html) {
      var dom = document.createElement('div');
      dom.innerHTML = html;
      $(dom)
        .find('.emoji')
        .each((i, item) => {
          let alt = $(item).attr('alt');
          $(item).replaceWith(alt);
        });
      return $(dom).html().replace(/<br>/g, '\n').replace(/<div>/g, '').replace(/<\/div>/g, '');
    },
    setFocus() {
      this.$nextTick(() => {
        let el = this.$refs.contenteditable;
        el.focus();
      });
    },
    show() {
      this.dialog = true;
    },
    setSel() {
      this.sel = window.getSelection();
      this.range = window.getSelection().getRangeAt(0);
    },
    input(e) {
      this.content = this.$refs.contenteditable.innerHTML;
    },
    insertHtmlAtCaret(html) {
      var sel, range;
      if (window.getSelection) {
        sel = this.sel;
        if (sel.getRangeAt && sel.rangeCount) {
          range = this.range;
          range.deleteContents();
          var el = document.createElement('div');
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.collapseToEnd();
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type != 'Control') {
        document.selection.createRange().pasteHTML(html);
      }
    },
    addEmoji(item) {
      let emoji = `<img class="emoji" src="${this.publicPath}emoji/${
        item.name
      }.png"/>`;
      this.insertHtmlAtCaret(emoji);
      this.input();
    },
  },
  mounted() {},
};
</script>
